import { render } from "./StartVirtualMachine.vue?vue&type=template&id=590de6d2&scoped=true"
import script from "./StartVirtualMachine.vue?vue&type=script&lang=js"
export * from "./StartVirtualMachine.vue?vue&type=script&lang=js"

import "./StartVirtualMachine.vue?vue&type=style&index=0&id=590de6d2&scoped=true&lang=less"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590de6d2"]])

export default __exports__